/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CreditcardpaymentresultId200,
  GetApiV1CreditcardpaymentresultId401,
  GetApiV1CreditcardpaymentresultId404,
  GetApiV1CreditcardpaymentresultId500,
  GetApiV1CreditcardpaymentresultIdPathParams,
  GetApiV1CreditcardpaymentresultIdQueryResponse,
} from "../../types/creditCardPaymentResultController/GetApiV1CreditcardpaymentresultId.ts";
import { creditCardPaymentResultDetailViewModelSchema } from "../creditCardPaymentResultDetailViewModelSchema.ts";

export const getApiV1CreditcardpaymentresultIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1CreditcardpaymentresultIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CreditcardpaymentresultId200Schema = z.lazy(
  () => creditCardPaymentResultDetailViewModelSchema,
) as unknown as ToZod<GetApiV1CreditcardpaymentresultId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CreditcardpaymentresultId401Schema =
  z.any() as unknown as ToZod<GetApiV1CreditcardpaymentresultId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CreditcardpaymentresultId404Schema =
  z.any() as unknown as ToZod<GetApiV1CreditcardpaymentresultId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CreditcardpaymentresultId500Schema =
  z.any() as unknown as ToZod<GetApiV1CreditcardpaymentresultId500>;

export const getApiV1CreditcardpaymentresultIdQueryResponseSchema = z.lazy(
  () => getApiV1CreditcardpaymentresultId200Schema,
) as unknown as ToZod<GetApiV1CreditcardpaymentresultIdQueryResponse>;
